module.exports = __webpack_public_path__ + "media/images/application/image-idea-5d5bf62a3c131f9cd6a981a74ac31c28.svg";